// Shared crypto pairs list — mirrors server/services/alpaca.js CRYPTO_BASE_PAIRS.
// Update both together when adding/removing pairs.
// Source of truth: https://alpaca.markets/support/what-cryptocurrencies-does-alpaca-currently-support

export const CRYPTO_USD_PAIRS = [
  { symbol: 'AAVE/USD',   name: 'Aave' },
  { symbol: 'ADA/USD',    name: 'Cardano' },
  { symbol: 'ARB/USD',    name: 'Arbitrum' },
  { symbol: 'AVAX/USD',   name: 'Avalanche' },
  { symbol: 'BAT/USD',    name: 'Basic Attention Token' },
  { symbol: 'BCH/USD',    name: 'Bitcoin Cash' },
  { symbol: 'BONK/USD',   name: 'Bonk' },
  { symbol: 'BTC/USD',    name: 'Bitcoin' },
  { symbol: 'CRV/USD',    name: 'Curve' },
  { symbol: 'DOGE/USD',   name: 'Dogecoin' },
  { symbol: 'DOT/USD',    name: 'Polkadot' },
  { symbol: 'ETH/USD',    name: 'Ethereum' },
  { symbol: 'FIL/USD',    name: 'Filecoin' },
  { symbol: 'GRT/USD',    name: 'The Graph' },
  { symbol: 'HYPE/USD',   name: 'Hyperliquid' },
  { symbol: 'LDO/USD',    name: 'Lido DAO' },
  { symbol: 'LINK/USD',   name: 'Chainlink' },
  { symbol: 'LTC/USD',    name: 'Litecoin' },
  { symbol: 'ONDO/USD',   name: 'Ondo' },
  { symbol: 'PAXG/USD',   name: 'PAX Gold' },
  { symbol: 'PEPE/USD',   name: 'Pepe' },
  { symbol: 'POL/USD',    name: 'Polygon' },
  { symbol: 'RENDER/USD', name: 'Render' },
  { symbol: 'SHIB/USD',   name: 'Shiba Inu' },
  { symbol: 'SKY/USD',    name: 'Sky' },
  { symbol: 'SOL/USD',    name: 'Solana' },
  { symbol: 'SUSHI/USD',  name: 'SushiSwap' },
  { symbol: 'TRUMP/USD',  name: 'TRUMP' },
  { symbol: 'UNI/USD',    name: 'Uniswap' },
  { symbol: 'USDC/USD',   name: 'USD Coin' },
  { symbol: 'USDG/USD',   name: 'Global Dollar' },
  { symbol: 'USDT/USD',   name: 'Tether' },
  { symbol: 'WIF/USD',    name: 'dogwifhat' },
  { symbol: 'XRP/USD',    name: 'XRP' },
  { symbol: 'XTZ/USD',    name: 'Tezos' },
  { symbol: 'YFI/USD',    name: 'yearn.finance' },
];

export const CRYPTO_CROSS_PAIRS = [
  // USDC-quoted
  { symbol: 'AAVE/USDC',  name: 'Aave / USD Coin' },
  { symbol: 'AVAX/USDC',  name: 'Avalanche / USD Coin' },
  { symbol: 'BAT/USDC',   name: 'Basic Attention Token / USD Coin' },
  { symbol: 'BCH/USDC',   name: 'Bitcoin Cash / USD Coin' },
  { symbol: 'BTC/USDC',   name: 'Bitcoin / USD Coin' },
  { symbol: 'CRV/USDC',   name: 'Curve / USD Coin' },
  { symbol: 'DOGE/USDC',  name: 'Dogecoin / USD Coin' },
  { symbol: 'DOT/USDC',   name: 'Polkadot / USD Coin' },
  { symbol: 'ETH/USDC',   name: 'Ethereum / USD Coin' },
  { symbol: 'GRT/USDC',   name: 'The Graph / USD Coin' },
  { symbol: 'LINK/USDC',  name: 'Chainlink / USD Coin' },
  { symbol: 'LTC/USDC',   name: 'Litecoin / USD Coin' },
  { symbol: 'SHIB/USDC',  name: 'Shiba Inu / USD Coin' },
  { symbol: 'SOL/USDC',   name: 'Solana / USD Coin' },
  { symbol: 'SUSHI/USDC', name: 'SushiSwap / USD Coin' },
  { symbol: 'UNI/USDC',   name: 'Uniswap / USD Coin' },
  { symbol: 'USDT/USDC',  name: 'Tether / USD Coin' },
  { symbol: 'XTZ/USDC',   name: 'Tezos / USD Coin' },
  { symbol: 'YFI/USDC',   name: 'yearn.finance / USD Coin' },
  // USDT-quoted
  { symbol: 'AAVE/USDT',  name: 'Aave / Tether' },
  { symbol: 'AVAX/USDT',  name: 'Avalanche / Tether' },
  { symbol: 'BCH/USDT',   name: 'Bitcoin Cash / Tether' },
  { symbol: 'BTC/USDT',   name: 'Bitcoin / Tether' },
  { symbol: 'DOGE/USDT',  name: 'Dogecoin / Tether' },
  { symbol: 'ETH/USDT',   name: 'Ethereum / Tether' },
  { symbol: 'LINK/USDT',  name: 'Chainlink / Tether' },
  { symbol: 'LTC/USDT',   name: 'Litecoin / Tether' },
  { symbol: 'SHIB/USDT',  name: 'Shiba Inu / Tether' },
  { symbol: 'SOL/USDT',   name: 'Solana / Tether' },
  { symbol: 'SUSHI/USDT', name: 'SushiSwap / Tether' },
  { symbol: 'UNI/USDT',   name: 'Uniswap / Tether' },
  { symbol: 'YFI/USDT',   name: 'yearn.finance / Tether' },
  // BTC-quoted
  { symbol: 'BCH/BTC',    name: 'Bitcoin Cash / Bitcoin' },
  { symbol: 'ETH/BTC',    name: 'Ethereum / Bitcoin' },
  { symbol: 'LINK/BTC',   name: 'Chainlink / Bitcoin' },
  { symbol: 'LTC/BTC',    name: 'Litecoin / Bitcoin' },
  { symbol: 'UNI/BTC',    name: 'Uniswap / Bitcoin' },
];

export const ALL_CRYPTO_PAIRS = [...CRYPTO_USD_PAIRS, ...CRYPTO_CROSS_PAIRS];

// Given a base asset (e.g. "ETH"), return all known pairs sorted USD first.
export function getPairsForBase(base) {
  const upper = base.toUpperCase();
  return ALL_CRYPTO_PAIRS.filter(p => p.symbol.startsWith(upper + '/'));
}
